// extracted by mini-css-extract-plugin
var _1 = "DefaultElement_destContainer__d9266";
export { _1 as "destContainer" }
